import r, { useEffect as e, useLayoutEffect as t, useRef as o, useState as a, isValidElement as n, forwardRef as s, useMemo as i, useCallback as l } from "react";
const c = "undefined" == typeof window ? e : t, f = (r2) => "number" == typeof r2 && r2 > 0, u = (r2) => Math.round(100 * r2) / 100, d = (r2) => Math.round(2 * r2) / 2, m = {}, h = ({ itemShapes: e2, testId: t2, itemStrokeWidth: n2 = 0, orientationProp: s2 = "horizontal", hasHalfFill: i2 = false }) => {
  const l2 = n2 > 0 ? -n2 / 2 : 0, f2 = n2 > 0 ? `${l2} ${l2}` : "0 0", d2 = o(null), m2 = o(null), [h2, p2] = a(null);
  c(() => {
    var _a;
    i2 && !m2.current && (m2.current = (Math.random() + 1).toString(36).substring(7));
    const { width: r2, height: e3, x: t3, y: o2 } = (_a = d2 == null ? void 0 : d2.current) == null ? void 0 : _a.getBBox();
    if ("number" == typeof r2 && "number" == typeof e3 && "number" == typeof t3 && "number" == typeof o2) {
      const a2 = `${f2} ${u(r2 + n2)} ${u(e3 + n2)}`, s3 = `${0 === t3 ? 0 : -1 * u(t3)} ${0 === o2 ? 0 : -1 * u(o2)}`;
      p2({ viewBox: a2, translateData: s3 });
    }
  }, [e2, n2, i2]);
  return r.createElement("svg", { ...n2 > 0 ? { strokeWidth: n2 } : {}, "aria-hidden": "true", className: "rr--svg", xmlns: "http://www.w3.org/2000/svg", viewBox: h2 ? h2.viewBox : "0 0 0 0", preserveAspectRatio: "xMidYMid meet" }, i2 && r.createElement("defs", {}, r.createElement("linearGradient", { id: `${m2.current}_rr_hf`, ..."vertical" === s2 ? { gradientTransform: "rotate(90)" } : {} }, r.createElement("stop", { className: "rr--svg-stop-1", offset: "50%" }), r.createElement("stop", { className: "rr--svg-stop-2", offset: "50%" }))), r.createElement("g", { ref: d2, ...(() => {
    if (h2) {
      const r2 = `translate(${h2 == null ? void 0 : h2.translateData})`;
      return "translate(0 0)" === r2 ? {} : { transform: r2 };
    }
    return { transform: void 0 };
  })(), ...i2 ? { fill: `url('#${m2.current}_rr_hf')` } : {} }, e2));
}, p = (r2, e2, t2) => {
  const o2 = { ...r2 }, a2 = {};
  let n2;
  return Object.entries(o2).forEach(([r3, t3]) => ((r4, e3, t4) => {
    switch (e3) {
      case "activeFillColor":
        r4["--rr--fill-on-color"] = t4;
        break;
      case "activeBoxColor":
        r4["--rr--box-on-color"] = t4;
        break;
      case "activeBoxBorderColor":
        r4["--rr--border-on-color"] = t4;
        break;
      case "activeStrokeColor":
        r4["--rr--stroke-on-color"] = t4;
    }
  })(a2, r3, t3[e2])), true === t2 ? (n2 = Array(e2).fill({}), n2.push(a2)) : n2 = Array(e2 + 1).fill(a2), n2;
}, b = (r2, e2) => {
  const t2 = {};
  "number" == typeof e2 && e2 > 0 && (t2["--rr--border-width"] = `${e2}px`);
  const o2 = Object.entries(r2);
  return o2.length > 0 && o2.forEach(([r3, e3]) => {
    ((r4, e4, t3) => {
      switch (e4) {
        case "activeFillColor":
          r4["--rr--fill-on-color"] = t3;
          break;
        case "activeBoxColor":
          r4["--rr--box-on-color"] = t3;
          break;
        case "activeBoxBorderColor":
          r4["--rr--border-on-color"] = t3;
          break;
        case "activeStrokeColor":
          r4["--rr--stroke-on-color"] = t3;
          break;
        case "inactiveFillColor":
          r4["--rr--fill-off-color"] = t3;
          break;
        case "inactiveBoxColor":
          r4["--rr--box-off-color"] = t3;
          break;
        case "inactiveBoxBorderColor":
          r4["--rr--border-off-color"] = t3;
          break;
        case "inactiveStrokeColor":
          r4["--rr--stroke-off-color"] = t3;
      }
    })(t2, r3, e3);
  }), t2;
}, v = ["activeFillColor", "activeStrokeColor", "activeBoxColor", "activeBoxBorderColor"], y = (r2, e2) => Array(r2).fill(void 0).map((r3, t2) => -1 === e2 || 0 === e2 ? 0 === t2 ? 0 : -1 : e2 > 0 ? t2 === e2 ? 0 : -1 : void 0), g = "@smastrom/react-rating", x = (r2, e2) => (r2.shouldRender = false, r2.errorReason = ((r3) => `[${g}] - Nothing's returned from rendering. Reason: ${r3}.`)(e2), r2), C = r.createElement("polygon", { points: "478.53 189 318.53 152.69 239.26 0 160 152.69 0 189 111.02 303.45 84 478.53 239.26 396.63 394.53 478.53 367.51 303.45 478.53 189" }), k = { itemShapes: C, itemStrokeWidth: 40, activeFillColor: "#ffb23f", inactiveFillColor: "#FFF7ED", activeStrokeColor: "#e17b21", inactiveStrokeColor: "#eda76a" }, S = s(({ value: t2, items: s2 = 5, readOnly: c2 = false, onChange: u2, onHoverChange: g2, highlightOnlySelected: C2 = false, resetOnSecondClick: S2 = false, disableKeyboard: $ = false, orientation: A = "horizontal", spaceBetween: w = "none", spaceInside: B = "small", radius: E = "none", transition: F = "colors", itemStyles: N = k, isRequired: R = true, halfFillMode: I = "svg", visibleLabelId: M, visibleItemLabelIds: O, invisibleLabel: W = false === c2 ? "Rating" : `Rated ${t2} on ${s2}`, invisibleItemLabels: D, id: L, className: V, style: _ }, j) => {
  const z = o([]), H = Array.from(Array(s2), (r2, e2) => e2 + 1), P = c2 && !Number.isInteger(t2), q = P && false === C2, T = false === c2 && false === $, J = P && true === C2 ? Math.round(t2) : t2, K = q ? ((r2, e2) => {
    const t3 = d(e2);
    return Number.isInteger(t3) ? r2.indexOf(t3) : Math.floor(t3);
  })(H, J) : H.indexOf(J), X = q && !((r2) => Number.isInteger(d(r2)))(J), { itemShapes: G, itemStrokeWidth: U, boxBorderWidth: Y } = N, Q = f(U) ? U : 0, Z = f(Y) ? Y : 0, rr = "box" === I ? "box" : "svg", er = J >= 0.25, { staticColors: tr, arrayColors: or } = i(() => {
    const { itemShapes: r2, itemStrokeWidth: e2, boxBorderWidth: t3, ...o2 } = N;
    return ((r3, e3, t4, o3) => {
      const a2 = { ...r3 }, n2 = {};
      e3 && ("box" === o3 ? delete a2.activeFillColor : delete a2.activeBoxColor), 0 === t4 && (delete a2.activeStrokeColor, delete a2.inactiveStrokeColor);
      const s3 = Object.entries(a2);
      return s3.length > 0 && s3.forEach(([r4, e4]) => {
        Array.isArray(e4) || "string" == typeof e4 ? Array.isArray(e4) && v.forEach((t5) => {
          if (t5 === r4) {
            const t6 = e4.filter((r5) => "string" == typeof r5);
            t6.length > 0 ? (n2[r4] = t6, delete a2[r4]) : delete a2[r4];
          } else
            delete a2[r4];
        }) : delete a2[r4];
      }), { arrayColors: n2, staticColors: a2 };
    })(o2, X, Q, rr);
  }, [N, X, Q, rr]), ar = Object.keys(or).length > 0, nr = l((r2) => X ? ((r3, e2, t3) => {
    const o2 = Math.floor(d(r3));
    return Array(e2).fill(void 0).map((r4, e3) => "box" === t3 ? e3 > o2 ? "rr--hf-box-off" : e3 === o2 ? "rr--hf-box-int" : "rr--hf-box-on" : e3 > o2 ? "rr--hf-svg-off" : "rr--hf-svg-on");
  })(J, s2, rr) : ((r3, e2, t3) => Array(e2).fill(void 0).map((e3, o2) => false === r3 ? o2 <= t3 ? "rr--on" : "rr--off" : o2 === t3 ? "rr--on" : "rr--off"))(C2, s2, r2), [X, C2, J, s2, rr]), sr = l((r2, e2) => ({ dynamicClassNames: nr(r2), dynamicCssVars: e2 && ar ? p(or, r2, C2) : [] }), [nr, or, ar, C2]), [ir, lr] = a({ staticCssVars: b(tr, Z), ...sr(K, er) }), [cr, fr] = a(() => T ? y(s2, K) : []);
  e(() => {
    lr({ staticCssVars: b(tr, Z), ...sr(K, er) });
  }, [tr, sr, Z, K, er]), e(() => {
    T && fr(() => y(s2, K));
  }, [T, K, s2]);
  const { shouldRender: ur, errorReason: dr } = ((r2, e2, t3, o2, a2) => {
    const s3 = { shouldRender: true, errorReason: "" };
    if ("number" != typeof r2 || r2 < 1 || r2 > 10)
      return x(s3, " is invalid");
    if ("number" != typeof e2 || e2 < 0 || e2 > r2)
      return x(s3, "value is invalid");
    if (false === t3 && "function" != typeof o2)
      return x(s3, "onChange is required");
    if (false === t3 && !Number.isInteger(e2))
      return x(s3, "Value is not an integer");
    if (!a2)
      return x(s3, "itemStyles needs at least the property itemShapes set");
    if (!Array.isArray(a2) && !n(a2))
      return x(s3, "itemShapes is not a valid JSX element");
    if (Array.isArray(a2)) {
      if (a2.length !== r2)
        return x(s3, "itemShapes length mismatch");
      if (!a2.every((r3) => n(r3)))
        return x(s3, "itemShapes is not a valid JSX element");
    }
    return s3;
  })(s2, t2, c2, u2, G);
  if (!ur)
    return console.error(dr), null;
  const mr = () => {
    "function" == typeof g2 && g2(0), lr({ ...ir, ...sr(K, er) });
  }, hr = (r2) => false === $ ? { tabIndex: cr[r2], onKeyDown: (e2) => ((r3, e3) => {
    const t3 = e3 - 1, o2 = e3 + 1, a2 = H.length - 1, n2 = a2 === e3, i2 = 0 === e3;
    switch (r3.code) {
      case "Shift":
        return true;
      case "Tab":
        return K !== e3 && setTimeout(() => {
          fr(y(s2, K));
        }), true;
      case "Enter":
      case "Space":
        return r3.preventDefault(), u2(e3 !== K ? H[e3] : 0);
      case "ArrowDown":
      case "ArrowRight":
        {
          const r4 = n2 ? 0 : o2;
          fr(y(s2, r4)), z.current[r4].focus();
        }
        break;
      case "ArrowUp":
      case "ArrowLeft": {
        const r4 = i2 ? a2 : t3;
        fr(y(s2, r4)), z.current[r4].focus();
      }
    }
    r3.preventDefault(), r3.stopPropagation();
  })(e2, r2) } : {}, pr = (r2) => {
    var _a;
    if (false === c2) {
      const e2 = () => Array.isArray(D) ? D : H.map((r3, e3) => `Rate ${H[e3]}`), t3 = {};
      return Array.isArray(O) ? t3["aria-labelledby"] = O[r2] : t3["aria-label"] = (_a = e2()) == null ? void 0 : _a[r2], { ...t3, "aria-checked": H[r2] === J, role: "radio", ref: (e3) => z.current[r2] = e3, onClick: (e3) => ((r3, e4) => {
        r3.stopPropagation(), u2(true === S2 && K === e4 ? 0 : H[e4]);
      })(e3, r2), onMouseEnter: () => {
        return e3 = r2, "function" == typeof g2 && g2(H[e3]), void lr({ ...ir, ...sr(e3, true) });
        var e3;
      }, onMouseLeave: mr, ...hr(r2) };
    }
    return {};
  }, br = (r2) => {
    const e2 = { itemShapes: Array.isArray(G) ? G[r2] : G, itemStrokeWidth: Q, hasHalfFill: false, orientationProp: A };
    return X && "svg" === rr && (e2.hasHalfFill = r2 === K), e2;
  };
  return r.createElement("div", { ...m, ref: j, id: L, style: { ..._, ...ir.staticCssVars }, className: (() => {
    const r2 = false === c2 ? "rr--pointer" : "", e2 = "rr--dir-" + ("vertical" === A ? "y" : "x"), t3 = "string" == typeof E && "none" !== E ? ((r3) => {
      switch (r3) {
        case "small":
          return "rr--rx-sm";
        case "medium":
          return "rr--rx-md";
        case "large":
          return "rr--rx-lg";
        case "full":
          return "rr--rx-full";
        default:
          return "";
      }
    })(E) : "";
    return `rr--group ${e2} ${Q > 0 ? "rr--has-stroke" : ""} ${Z > 0 ? "rr--has-border" : ""}
      ${false === c2 && "none" !== F ? ((r3) => {
      switch (r3) {
        case "zoom":
          return "rr--fx-zoom rr--fx-colors";
        case "position":
          return "rr--fx-position rr--fx-colors";
        case "opacity":
          return "rr--fx-opacity rr--fx-colors";
        case "colors":
          return "rr--fx-colors";
        default:
          return "";
      }
    })(F) : ""} ${t3} ${r2} ${"string" == typeof w && "none" !== w ? ((r3) => {
      switch (r3) {
        case "small":
          return "rr--gap-sm";
        case "medium":
          return "rr--gap-md";
        case "large":
          return "rr--gap-lg";
        default:
          return "";
      }
    })(w) : ""}
      ${"string" == typeof B && "none" !== B ? ((r3) => {
      switch (r3) {
        case "small":
          return "rr--space-sm";
        case "medium":
          return "rr--space-md";
        case "large":
          return "rr--space-lg";
        default:
          return "";
      }
    })(B) : ""} ${V || ""}`.replace(/  +/g, " ").trimEnd();
  })(), ...(() => {
    if (false === c2) {
      const r2 = { role: "radiogroup", "aria-required": true === R };
      return true === R && (r2["aria-invalid"] = J <= 0), "string" == typeof M && M.length > 0 ? r2["aria-labelledby"] = M : r2["aria-label"] = W, r2;
    }
    return { role: "img", "aria-label": W };
  })() }, H.map((e2, t3) => {
    var _a;
    return r.createElement("div", { key: `rr_box_${t3}`, className: `rr--box ${ir.dynamicClassNames[t3]}`, style: (_a = ir == null ? void 0 : ir.dynamicCssVars) == null ? void 0 : _a[t3], ...pr(t3) }, r.createElement(h, { ...br(t3) }));
  }));
});
export {
  S as Rating,
  C as Star
};
